export default __webpack_public_path__ + "static/banner-renovation-keep-your-cool-smart-hacks-e8a70f4834dc2e327977e45b585027bb.jpg";